<nav aria-label="breadcrumb" (click)="paymentShowToggle()">
    <ol class="breadcrumb section-header-breadcrumb">
      <li class="breadcrumb-item active" aria-current="page" >
        <div class="breadcrumb-content">
        <i class="fa fa-plus breadcrumb-icon"  *ngIf="!isPaymentShow"></i>
        <i class="fa fa-minus breadcrumb-icon"  *ngIf="isPaymentShow"></i>
        <p class="h5 breadcrumb-text"> Policy Details</p>
      </div></li>
    </ol>
  </nav>
  <div *ngIf = "isPaymentShow">
    <a (click)="paymentPlanFormToggle()" class="btn btn-sm btn-success mb-2 me-2">Create Payment</a>
    <a (click)="paymentDetailFormToggle()" class="btn btn-sm btn-primary mb-2">Show Past Transactions</a> 
      <div *ngIf="isPaymentAddFormShow">
          <form [formGroup]="paymentForm" (ngSubmit)="onPaymentSubmit()">
              <div class="row g-3">
                <div class="mb-3 col">
                  <label for="paymentAmount">Policy Payment Amount</label>
                  <input type="number" formControlName="paymentAmount" class="form-control" [ngClass]="{ 'is-invalid': submitted && pmntForm.paymentAmount.errors }" />
                  <div *ngIf="submitted && pmntForm.paymentAmount.errors" class="invalid-feedback">
                      <div *ngIf="pmntForm.paymentAmount.errors.required">Policy Payment Amount is required</div>
                  </div>
              </div>
                <div class="mb-3 col">
                  <label for="insuranceCompany">Insurance Company</label>
                  <select class="form-select" formControlName="insuranceCompany" [ngClass]="{ 'is-invalid': submitted && pmntForm.insuranceCompany.errors }" >
                      <option *ngFor="let insuranceCo of insuranceCompanies " [ngValue]="insuranceCo.key">
                        {{ insuranceCo.name }}
                      </option>
                    </select>
                        <div *ngIf="submitted && pmntForm.insuranceCompany.errors" class="invalid-feedback">
                      <div *ngIf="pmntForm.insuranceCompany.errors.required">Insurance Company is required</div>
                  </div>
              </div>
              <div class="mb-3 col">
                      <label for="comments">Comments</label>
                      <input type="text" formControlName="comments" class="form-control" [ngClass]="{ 'is-invalid': submitted && pmntForm.comments.errors }" />
                      <div *ngIf="submitted && pmntForm.comments.errors" class="invalid-feedback">
                          <div *ngIf="pmntForm.comments.errors.required">Comments is required</div>
                      </div>
                  </div>
              </div>
              <div class="mb-3">
                <button [disabled]="loading" class="btn btn-primary me-2">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                    Save
                </button>
                <button class="btn btn-secondary me-2" type="reset" (click)="onReset()">
                  Refresh Page
              </button>
                <a (click)="paymentPlanFormToggle()" class="btn btn-link" >Cancel</a>
      
            </div>
            <div class="mb-3">
              <div class="alert alert-success" role="alert" *ngIf="isBalanceUpdated">
                <i class="fa fa-check-circle me-1"></i> Balance Updated! Please refresh page to see new balance.
              </div>
          </div>

          </form>
      </div>
      <div *ngIf="isPaymentDetailShow">
        <form [formGroup]="paymentDetailForm" (ngSubmit)="getPaymentDetail()">
          <div class="row g-3">
            <div class="mb-3 col">
              <label for="certificateNumber">Number of Records</label>
              <select class="form-select" formControlName="recordCount" [ngClass]="{ 'is-invalid': submitted && pmntDtlForm.recordCount.errors }" >
                <option *ngFor="let recordCount of numberofRecords" [ngValue]="recordCount">
                  {{ recordCount }}
                </option>
              </select>
            <div *ngIf="submitted && pmntDtlForm.recordCount.errors" class="invalid-feedback">
                <div *ngIf="pmntDtlForm.recordCount.errors.required">Record Count is required</div>
            </div>
            </div>
          </div>
          <div class="row g-3">
              <div class="mb-3">
                <button [disabled]="loading" class="btn btn-primary">
                  <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                  Get Payment Details
                </button>
              </div>
            </div>
          </form>
          <div class="table-responsive">
          <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Payment Date</th>
                    <th>Payment Amount</th>
                    <th>Comments</th>
                    <th>Payment UserId</th>
                    <th>Dealer Balance After</th>
                    <th>Payment Username</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let paymentDtl of paymentDetails">
                    <td>{{paymentDtl.paymentDate}}</td>
                    <td>{{paymentDtl.paymentAmount}}</td>
                    <td>{{paymentDtl.comments}}</td>
                    <td>{{paymentDtl.userId}}</td>
                    <td>{{paymentDtl.dealerBalanceAfter}}</td>
                    <td>{{paymentDtl.userName}}</td>
                </tr>
                <tr *ngIf="!paymentDetails">
                    <td colspan="6" class="text-center">
                        <span class="text-muted">No records found.</span>
                    </td>
                </tr>
            </tbody>
        </table>
          </div>
          </div>
          
      </div>
